import React from 'react';
import { OrderImportTemplate } from 'themes/modules/order/pages';
import { inject, observer } from 'mobx-react';

@inject(i => ({
	marketplaceOrderListViewStore: i.rootStore.marketplaceOrderListViewStore,
}))
@observer
class OrderImport extends React.Component {
	render() {
		return <OrderImportTemplate {...this.props} />;
	}
}

export default OrderImport;
